import * as yup from 'yup';
import { FIRST_NAME_INVALID, LAST_NAME_INVALID, EMAIL_REQUIRED, USER_TYPE_REQUIRED, EMAIL_INVALID, LAST_NAME_REQUIRED, FIRST_NAME_REQUIRED, FIRST_NAME_TOO_LONG, LAST_NAME_TOO_LONG, } from '../../constants/field-error-messages';
import { NAME_REGEX } from '../../constants/regex';
export var addUserValidationSchema = yup.object().shape({
    role: yup
        .mixed()
        .required(USER_TYPE_REQUIRED.message)
        .oneOf(['Runner', 'Purchaser', 'Admin']),
    email: yup
        .string()
        .email(EMAIL_INVALID.message)
        .required(EMAIL_REQUIRED.message),
    firstName: yup
        .string()
        .trim()
        .max(40, FIRST_NAME_TOO_LONG.message)
        .required(FIRST_NAME_REQUIRED.message)
        .matches(NAME_REGEX, FIRST_NAME_INVALID.message),
    lastName: yup
        .string()
        .trim()
        .max(60, LAST_NAME_TOO_LONG.message)
        .required(LAST_NAME_REQUIRED.message)
        .matches(NAME_REGEX, LAST_NAME_INVALID.message),
});
